if (!customElements.get('discount-card-game')) {
  customElements.define('discount-card-game', class extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey;
      this.sessionDismissKey = this.dataset.sessionDismissKey;
      this.sessionAutoCloseKey = this.dataset.sessionAutoCloseKey;
      this.rememberEmailVisit();
      if (this.wasPlayed() || this.wasDismissedThisSession()) return;
      this.hidden = false;
      this.overlay = this.querySelector('[data-overlay]');
      this.dialog = this.querySelector('.discount-game__dialog');
      this.launcher = this.querySelector('.discount-game__launcher');
      this.closeButton = this.querySelector('[data-close]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.progress = this.querySelector('[data-progress]');
      this.playView = this.querySelector('[data-play-view]');
      this.emailView = this.querySelector('[data-email-view]');
      this.form = this.querySelector('form');
      this.result = this.querySelector('[data-result]');
      this.submitStatus = this.querySelector('[data-submit-status]');
      this.count = 0;
      this.suspendedByCart = false;

      this.launcherOpen = this.querySelector('.discount-game__launcher-open');
      this.launcherDismiss = this.querySelector('[data-dismiss-launcher]');
      this.launcherOpen.addEventListener('click', () => this.open());
      this.launcherDismiss.addEventListener('click', () => this.dismissLauncher());
      this.closeButton.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (event) => { if (event.target === this.overlay) this.close(); });
      this.cards.forEach((card) => card.addEventListener('click', () => this.reveal(card)));
      this.querySelector('[data-code]').addEventListener('click', (event) => this.copyCode(event.currentTarget));
      this.form.addEventListener('submit', (event) => this.submit(event), true);
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !this.overlay.hidden) this.close(); });
      document.addEventListener('cart-drawer:opening', () => this.suspendForCart());
      document.addEventListener('cart-drawer:closed', () => this.resumeAfterCart());

      if (!this.wasAutoClosedThisSession()) {
        this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 10000);
      }
    }

    wasPlayed() {
      try { return localStorage.getItem(this.key) === '1'; } catch (_) { return false; }
    }

    markPlayed() {
      try { localStorage.setItem(this.key, '1'); } catch (_) {}
      this.launcher.hidden = true;
    }

    wasDismissedThisSession() {
      try { return sessionStorage.getItem(this.sessionDismissKey) === '1'; } catch (_) { return false; }
    }

    wasAutoClosedThisSession() {
      try { return sessionStorage.getItem(this.sessionAutoCloseKey) === '1'; } catch (_) { return false; }
    }

    rememberEmailVisit() {
      const params = new URLSearchParams(window.location.search);
      const cameFromEmail = params.get('discount_game_email') === '1'
        || params.get('discount') === 'WILLKOMMEN10';
      if (!cameFromEmail) return;
      try { localStorage.setItem(this.key, '1'); } catch (_) {}
      params.delete('discount_game_email');
      if (params.get('discount') === 'WILLKOMMEN10') params.delete('discount');
      const cleanQuery = params.toString();
      window.history.replaceState({}, '', `${window.location.pathname}${cleanQuery ? `?${cleanQuery}` : ''}${window.location.hash}`);
    }

    dismissLauncher() {
      clearTimeout(this.timer);
      try { sessionStorage.setItem(this.sessionDismissKey, '1'); } catch (_) {}
      this.launcher.hidden = true;
    }

    open() {
      if (this.wasPlayed() && this.count < 3) return;
      if (document.querySelector('cart-drawer.active')) {
        this.suspendedByCart = true;
        return;
      }
      clearTimeout(this.timer);
      clearTimeout(this.closeRevealTimer);
      this.dialog.classList.remove('is-close-ready');
      this.overlay.hidden = false;
      document.body.classList.add('discount-game-open');
      this.closeRevealTimer = window.setTimeout(() => {
        this.dialog.classList.add('is-close-ready');
        this.closeButton.focus();
      }, 3000);
    }

    suspendForCart() {
      clearTimeout(this.timer);
      clearTimeout(this.closeRevealTimer);
      this.suspendedByCart = true;
      this.dialog.classList.remove('is-close-ready');
      this.overlay.hidden = true;
      document.body.classList.remove('discount-game-open');
    }

    resumeAfterCart() {
      if (!this.suspendedByCart || this.wasPlayed() || this.wasDismissedThisSession()) return;
      this.suspendedByCart = false;
      clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.open(), 1500);
    }

    close() {
      clearTimeout(this.closeRevealTimer);
      this.dialog.classList.remove('is-close-ready');
      this.overlay.hidden = true;
      document.body.classList.remove('discount-game-open');
      try { sessionStorage.setItem(this.sessionAutoCloseKey, '1'); } catch (_) {}
      if (!this.wasPlayed() && !this.launcher.hidden) this.launcherOpen.focus();
    }

    reveal(card) {
      if (card.classList.contains('is-revealed') || this.count >= 3) return;
      card.classList.add('is-revealed');
      card.setAttribute('aria-pressed', 'true');
      this.count += 1;
      this.progress.textContent = `${this.count} von 3 Karten gewählt`;
      if (this.count === 3) {
        window.setTimeout(() => {
          this.playView.hidden = true;
          this.emailView.hidden = false;
          this.emailView.querySelector('input').focus();
        }, 650);
      }
    }

    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      this.submitStatus.hidden = true;
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
          redirect: 'follow'
        });
        if (!response.ok) throw new Error(`Customer form failed with ${response.status}`);
        this.markPlayed();
        this.form.hidden = true;
        this.result.hidden = false;
        this.overlay.hidden = false;
        document.body.classList.add('discount-game-open');
      } catch (_) {
        button.disabled = false;
        this.submitStatus.hidden = false;
        this.overlay.hidden = false;
        document.body.classList.add('discount-game-open');
      }
    }

    async copyCode(button) {
      try {
        await navigator.clipboard.writeText(button.dataset.code);
        button.textContent = 'KOPIERT!';
      } catch (_) {}
    }
  });
}
